import React, { Component } from 'react';
import { connect } from '@souche-f2e/muji';
import { Button } from 'antd';
import { dispatch, getState } from '@@/store';
import Top from '../_components/Top';
import { TableContainer, WhiteSpace, PayMoney } from '@/components';
import { AddBuyer, CodeEdit } from '@/pages/DealerManage/Buyer/_components/index';
import { Table } from 'antd';
import Mapping from '@/shared/mapping';
import luban from '@souche-f2e/luban-js';
const mapStateToProps = (rootState) => ({
    _state: rootState.moneyManage,
    currentRoute: rootState.router,
});
class MoneyManage extends Component {
    constructor() {
        super(...arguments);
        this.onChange = (e) => {
            dispatch.moneyManage.SET_SEARCHDATA(e);
            dispatch.moneyManage.SET_PAGE_CURRENT(1);
            dispatch.moneyManage.loadList({});
            dispatch.moneyManage.loadMoney({});
        };
        this.confirmPay = () => {
            const { modalType, isSeller } = this.props._state;
            let lubanID = '';
            switch (modalType) {
                case 'charge':
                    lubanID = isSeller ? 'PSGJB-FIANCE-MJABZJ-CZ' : 'PSGJB-FIANCE-MJBZJ-TK';
                    break;
                case 'refund':
                    lubanID = isSeller ? 'PSGJB-FIANCE-MJABZJ-TK' : 'PSGJB-FIANCE-MJBZJ-TK';
                    break;
                default:
                    lubanID = undefined;
                    break;
            }
            luban.send({
                eventType: 'click',
                typeId: lubanID,
            });
            dispatch.moneyManage.loadMoney({});
            dispatch.moneyManage.loadList({});
            dispatch.moneyManage.HIDE_PAYCONFIRM();
        };
        this.closePayConfirm = () => {
            dispatch.moneyManage.HIDE_PAYCONFIRM();
        };
        this.changePage = (e) => {
            dispatch.moneyManage.SET_PAGE_CURRENT(e);
            dispatch.moneyManage.loadList({});
        };
        this.getExport = () => {
            // 搜索栏 以及 是否是卖家
            const { isSeller, searchData } = getState().moneyManage;
            // 获取导出的label和value
            const { seller_deposit_data, buyer_deposit_data } = Mapping.excelExportType;
            // 4.5期
            // 买家 传参数 distributor: 买家经销商姓名模糊查询 mobile: 手机号查询
            // 卖家 传参数 souCheCode: 卖家经销商code查询
            const { userName, mobile, souCheCode } = searchData;
            const _param = isSeller ? { souCheCode } : { distributor: userName, mobile };
            const exportObj = {
                type: 'finance',
                params: Object.assign(Object.assign({}, _param), { exportType: isSeller ? seller_deposit_data.value : buyer_deposit_data.value }),
                fileName: isSeller ? seller_deposit_data.label : buyer_deposit_data.label,
            };
            return exportObj;
        };
    }
    componentDidMount() {
        dispatch.moneyManage.loadMoney({});
        dispatch.moneyManage.loadList({});
    }
    componentWillUnmount() {
        dispatch.moneyManage.RESET_STATE2();
    }
    render() {
        const { columns, data, totalNum, showPayConfirm, modalType, availableMoney, frozenMoney, totalMoney, pageIndex, pageSize, choosedOrderId, choosedHandPrice, tableLoading, isSeller, columnsBuyer, } = this.props._state;
        const exportObj = this.getExport();
        const tableColums = isSeller ? columns : columnsBuyer;
        return (<React.Fragment>
        <WhiteSpace h={20}/>
        <Top onChange={this.onChange} isSeller={isSeller}/>
        <WhiteSpace />
        <TableContainer totalNum={totalNum} exportObj={exportObj}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            width: '100%',
            paddingRight: '110px',
        }}>
            <div>
              <span style={{ marginRight: 25, fontWeight: 500 }}>可用保证金总额：{availableMoney} 元</span>
              <span style={{ marginRight: 25, fontWeight: 500 }}>冻结保证金总额：{frozenMoney} 元</span>
              <span style={{ marginRight: 25, fontWeight: 500 }}>保证金总额：{totalMoney} 元</span>
            </div>
            {!isSeller && <Button type={'primary'} onClick={() => {
            dispatch.buyer.SHOW_ADD_MODAL(false);
        }}>
                添加买家
              </Button>}
          </div>
          <Table dataSource={data} columns={tableColums} pagination={{
            current: pageIndex,
            pageSize,
            showQuickJumper: true,
            total: totalNum,
            onChange: this.changePage,
        }} loading={tableLoading}/>
        </TableContainer>
        <PayMoney orderId={choosedOrderId} isSeller={isSeller} isShow={showPayConfirm} price={choosedHandPrice} onCancel={this.closePayConfirm} onOk={this.confirmPay} type={modalType}/>
        {!isSeller && (<React.Fragment>
              <AddBuyer onOk={() => {
            dispatch.moneyManage.loadList({});
            dispatch.moneyManage.loadMoney({});
        }}/>
              <CodeEdit onOk={() => {
            dispatch.moneyManage.loadList({});
            dispatch.moneyManage.loadMoney({});
        }}/>
            </React.Fragment>)}
      </React.Fragment>);
    }
}
export default connect(mapStateToProps)(MoneyManage);
